import { opportunityActionTypes } from "./manageOpportunity.action";

const INITIAL_STATE = {
  projectType: ""
};

const setOpportunityData = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case opportunityActionTypes.SET_PROJECT_TYPE:
      return {
        ...state,
        projectType: action.payload,
      };
    default:
      return state;
  }
};

export default setOpportunityData;